import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PageDecorated } from 'pages/page';
import { ContentBox } from 'components/content-box';
import { VideoListDecorated } from 'components/video-list';
import { VideoCollection } from 'components/video-collection';
import { VideoControlsMenu, myVideosRequestAction, myVideosRequestMobileAction } from 'pages/my-videos.page';
import { VideoBoxDecorated } from 'components/video-box';
import { videoBoxRequestAction } from 'components/video-box/actions';
import { isIframe } from 'integration/integration.utils';
import { Header } from 'components/header';
import { ErrorEmptyChannel } from 'components/error-handle/errors/error-empty-channel';
import { SORTING_KEYS } from 'utils/enums';
import { MyVideosItemMenu } from 'pages/my-videos.page/fragments';
import { get } from 'lodash-es';
import { PersonInChargeMask } from './person-in-charge-mask';

const BASE_URL = '/my-videos';

export const MyVideosPageView = ({
  website,
  videoId,
  integration,
  collection,
  sort,
  pageNumber,
  userId,
  perPage,
  collectionPageNumber,
}) => {
  const { t } = useTranslation();

  return (
    <PageDecorated>
      {videoId && (
        <VideoBoxDecorated
          playerConfiguration={website.playerConfiguration}
          videoBoxRequestAction={videoBoxRequestAction(videoId)}
          withRelatedVideos={false}
          inlineVideoControls={VideoControlsMenu}
        />
      )}

      <div>
        {isIframe(integration) && <Header />}

        <ContentBox>
          <h1 className="title">{t('my_uploads')}</h1>

          {get(collection, 'totalCount', 0) === 0 && !get(collection, 'isLoading', true) && <ErrorEmptyChannel />}
          {/** Until issue with vmpro sorting is resolved withSort = false,
           after that this prop can be removed if not needed anymore */}
          <VideoCollection
            baseUrl={BASE_URL}
            withSort={false}
            sortBy={[SORTING_KEYS.display_date, SORTING_KEYS.title_asc, SORTING_KEYS.plays, SORTING_KEYS.rating]}
            loadCollectionAction={myVideosRequestAction(sort, userId, perPage, pageNumber)}
            loadMoreAction={myVideosRequestMobileAction(sort, userId, perPage, collectionPageNumber, collection.videos)}
          >
            <VideoListDecorated maskJSX={PersonInChargeMask} baseUrl={BASE_URL} contextMenu={MyVideosItemMenu} />
          </VideoCollection>
        </ContentBox>
      </div>
    </PageDecorated>
  );
};

MyVideosPageView.propTypes = {
  website: PropTypes.object.isRequired,
  videoId: PropTypes.string,
  integration: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
  sort: PropTypes.string,
  pageNumber: PropTypes.number,
  userId: PropTypes.number.isRequired,
};
